import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormControlProps,
  FormGroup,
  FormLabel,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import InputMask from 'react-input-mask';
import './styles.css';
import { useTheme } from 'styled-components';

export interface InputProps extends FormControlProps {
  type?: string;
  value: string | number;
  id?: string;
  mascara?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onBlur?: any;
  label?: string;
  textAlign?: 'left' | 'right' | 'center' | 'justify' | 'initial' | 'inherit';
  placeholder?: string;
  name?: string;
  required?: boolean;
  readonly?: boolean;
  linhas?: number;
  style?: React.CSSProperties;
}

const Input: React.FC<InputProps> = ({
  type = 'text',
  value,
  id,
  mascara,
  onChange,
  onBlur,
  label,
  textAlign = 'left',
  placeholder,
  name,
  required,
  readonly,
  linhas,
  style,
  ...props
}) => {
  const [showConfirmaSenha, setShowConfirmaSenha] = useState<boolean>(false);
  const [showSenha, setShowSenha] = useState<boolean>(false);
  const theme = useTheme();

  const FormInputMask = (
    mask: string,
    readOnlyInput: boolean | undefined,
    label?: string,
  ) => {
    if (!readOnlyInput) {
      return (
        <FormGroup controlId={id}>
          {label ? (
            <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
              {required ? (
                <>
                  <span
                    style={{
                      color: theme.colors.botaoConfirmar,
                      fontWeight: 'bold',
                    }}
                  >
                    {required ? (
                      <>
                        <span
                          style={{
                            color: theme.colors.botaoConfirmar,
                            fontWeight: 'bold',
                          }}
                        >
                          {label}
                        </span>
                        <span
                          style={{
                            color: theme.colors.vermelho,
                            fontWeight: 'bold',
                          }}
                        >
                          *
                        </span>
                      </>
                    ) : (
                      label
                    )}
                  </span>
                </>
              ) : (
                label
              )}
            </FormLabel>
          ) : (
            <></>
          )}
          <FormControl
            as={InputMask}
            mask={mask}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            name={name}
            onBlur={onBlur}
            readOnly={readonly}
            required={required}
            style={{
              borderRadius: '10px',
              border: `1px solid ${theme.colors.bordaInput}`,
              textAlign: `${textAlign}`,
            }}
            {...props}
          />
        </FormGroup>
      );
    } else {
      return (
        <FormGroup controlId={id}>
          {label ? (
            <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
              {required ? (
                <>
                  <span
                    style={{
                      color: theme.colors.botaoConfirmar,
                      fontWeight: 'bold',
                    }}
                  >
                    {label}
                  </span>
                  <span
                    style={{ color: theme.colors.vermelho, fontWeight: 'bold' }}
                  >
                    *
                  </span>
                </>
              ) : (
                label
              )}
            </FormLabel>
          ) : (
            <></>
          )}
          <FormControl
            as={InputMask}
            mask={mask}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            name={name}
            onBlur={onBlur}
            readOnly={readonly}
            style={{
              borderRadius: '10px',
              border: `1px solid ${theme.colors.bordaInput}`,
              textAlign: `${textAlign}`,
              backgroundColor: '#ebf0f8',
              ...(style || {}),
            }}
            {...props}
          />
        </FormGroup>
      );
    }
  };

  const FormInput = (
    type = 'text',
    readOnlyInput: boolean | undefined,
    label?: string,
  ) => {
    const commonStyles = {
      borderRadius: '10px',
      border: `1px solid ${theme.colors.bordaInput}`,
      textAlign: textAlign,
      ...style,
    };
    if (!readOnlyInput) {
      if (type === 'textarea') {
        return (
          <FormGroup controlId={id}>
            {label ? (
              <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
                {required ? (
                  <>
                    <span
                      style={{
                        color: theme.colors.botaoConfirmar,
                        fontWeight: 'bold',
                      }}
                    >
                      {label}
                    </span>
                    <span
                      style={{
                        color: theme.colors.vermelho,
                        fontWeight: 'bold',
                      }}
                    >
                      *
                    </span>
                  </>
                ) : (
                  label
                )}
              </FormLabel>
            ) : (
              <></>
            )}
            <FormControl
              as="textarea"
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              name={name}
              onBlur={onBlur}
              readOnly={readonly}
              rows={linhas}
              style={commonStyles}
              {...props}
            />
          </FormGroup>
        );
      } else if (type === 'password' && label) {
        if (id === 'senha') {
          return (
            // senha
            <>
              <FormGroup controlId={id}>
                <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
                  {required ? (
                    <>
                      <span
                        style={{
                          color: theme.colors.botaoConfirmar,
                          fontWeight: 'bold',
                        }}
                      >
                        {label}
                      </span>
                      <span
                        style={{
                          color: theme.colors.vermelho,
                          fontWeight: 'bold',
                        }}
                      >
                        *
                      </span>
                    </>
                  ) : (
                    label
                  )}
                </FormLabel>
              </FormGroup>

              <InputGroup>
                <FormControl
                  type={showSenha ? 'text' : `${type}`}
                  placeholder={placeholder}
                  value={value}
                  onChange={onChange}
                  name={name}
                  onBlur={onBlur}
                  style={commonStyles}
                  {...props}
                />
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 1000 }}
                  overlay={
                    <Tooltip id="regras-tooltip">
                      <p style={{ fontWeight: 'bold' }}>
                        Critérios para a nova senha:
                      </p>
                      <span>- Mínimo de 6 caracteres</span>
                    </Tooltip>
                  }
                >
                  <Button
                    style={{
                      width: '16%',
                      border: `1px solid ${theme.colors.bordaInput}`,
                      textAlign: 'center',
                      backgroundColor: theme.colors.white,
                      alignContent: 'center',
                      justifyContent: 'center',
                      display: 'flex',
                    }}
                  >
                    <span
                      className="material-icons"
                      style={{ color: theme.colors.botaoConfirmar }}
                    >
                      info_outline
                    </span>
                  </Button>
                </OverlayTrigger>

                <Button
                  onClick={() => setShowSenha((prev) => !prev)}
                  style={{
                    width: '16%',
                    borderRadius: '0 10px 10px 0',
                    border: `1px solid ${theme.colors.bordaInput}`,
                    textAlign: 'center',
                    backgroundColor: theme.colors.white,
                    alignContent: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                  }}
                >
                  <span
                    className="material-icons"
                    style={
                      showSenha
                        ? { color: theme.colors.botaoLaranja }
                        : { color: theme.colors.botaoConfirmar }
                    }
                  >
                    visibility
                  </span>
                </Button>
              </InputGroup>
            </>
          );
        } else {
          //confirma senha
          return (
            <>
              <FormGroup controlId={id}>
                <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
                  {required ? (
                    <>
                      <span
                        style={{
                          color: theme.colors.botaoConfirmar,
                          fontWeight: 'bold',
                        }}
                      >
                        {label}
                      </span>
                      <span
                        style={{
                          color: theme.colors.vermelho,
                          fontWeight: 'bold',
                        }}
                      >
                        *
                      </span>
                    </>
                  ) : (
                    label
                  )}
                </FormLabel>
              </FormGroup>
              <InputGroup>
                <FormControl
                  type={showConfirmaSenha ? 'text' : `${type}`}
                  placeholder={placeholder}
                  value={value}
                  onChange={onChange}
                  name={name}
                  onBlur={onBlur}
                  readOnly={readonly}
                  style={{
                    borderRadius: '10px 0 0 10px',
                    border: `1px solid ${theme.colors.bordaInput}`,
                    textAlign: `${textAlign}`,
                    backgroundColor: theme.colors.white,
                  }}
                  {...props}
                />

                <Button
                  onClick={() => setShowConfirmaSenha((prev) => !prev)}
                  style={{
                    width: '16%',
                    height: '50%',
                    borderRadius: '0 10px 10px 0',
                    border: `1px solid ${theme.colors.bordaInput}`,
                    backgroundColor: theme.colors.white,
                    alignContent: 'center',
                    justifyContent: 'center',
                    display: 'flex',
                  }}
                >
                  <span
                    className="material-icons"
                    style={
                      showConfirmaSenha
                        ? { color: theme.colors.botaoLaranja }
                        : { color: theme.colors.botaoConfirmar }
                    }
                  >
                    visibility
                  </span>
                </Button>
              </InputGroup>
            </>
          );
        }
      } else {
        // Renderização padrão
        return (
          <FormGroup controlId={id}>
            {label ? (
              <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
                {required ? (
                  <>
                    <span
                      style={{
                        color: theme.colors.botaoConfirmar,
                        fontWeight: 'bold',
                      }}
                    >
                      {label}
                    </span>
                    <span
                      style={{
                        color: theme.colors.vermelho,
                        fontWeight: 'bold',
                      }}
                    >
                      *
                    </span>
                  </>
                ) : (
                  label
                )}
              </FormLabel>
            ) : (
              <></>
            )}
            <FormControl
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              name={name}
              onBlur={onBlur}
              readOnly={readonly}
              style={commonStyles}
              {...props}
            />
          </FormGroup>
        );
      }
      // Caso seja readonly
    } else {
      if (type === 'textarea') {
        return (
          <FormGroup controlId={id}>
            <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
              {required ? (
                <>
                  <span
                    style={{
                      color: theme.colors.botaoConfirmar,
                      fontWeight: 'bold',
                    }}
                  >
                    {label}
                  </span>
                  <span
                    style={{ color: theme.colors.vermelho, fontWeight: 'bold' }}
                  >
                    *
                  </span>
                </>
              ) : (
                label
              )}
            </FormLabel>
            <FormControl
              as="textarea"
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              name={name}
              onBlur={onBlur}
              readOnly={readonly}
              style={{
                borderRadius: '10px',
                border: `1px solid ${theme.colors.bordaInput}`,
                textAlign: `${textAlign}`,
                backgroundColor: '#ebf0f8',
                ...(style || {}),
              }}
              {...props}
            />
          </FormGroup>
        );
      } else {
        // Renderização padrão
        return (
          <FormGroup controlId={id}>
            {label ? (
              <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
                {required ? (
                  <>
                    <span
                      style={{
                        color: theme.colors.botaoConfirmar,
                        fontWeight: 'bold',
                      }}
                    >
                      {label}
                    </span>
                    <span
                      style={{
                        color: theme.colors.vermelho,
                        fontWeight: 'bold',
                      }}
                    >
                      *
                    </span>
                  </>
                ) : (
                  label
                )}
              </FormLabel>
            ) : (
              <></>
            )}
            <FormControl
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              name={name}
              onBlur={onBlur}
              readOnly={readonly}
              style={{
                borderRadius: '10px',
                border: `1px solid ${theme.colors.bordaInput}`,
                textAlign: `${textAlign}`,
                backgroundColor: '#ebf0f8',
                ...(style || {}),
              }}
              {...props}
            />
          </FormGroup>
        );
      }
    }
  };

  // Renderização condicional de acordo com o tipo de máscara
  switch (mascara) {
    case 'cpf':
      return FormInputMask('999.999.999-99', readonly, label);
    case 'celular':
      return FormInputMask('(99) 99999-9999', readonly, label);
    case 'telefone':
      return FormInputMask('(99) 9999-9999', readonly, label);
    case 'cnpj':
      return FormInputMask('99.999.999/9999-99', readonly, label);
    case 'cep':
      return FormInputMask('99999-999', readonly, label);
    case 'latlong':
      return (
        <FormGroup controlId={id}>
          {label && (
            <FormLabel style={{ color: theme.colors.botaoConfirmar }}>
              {required ? (
                <>
                  <span style={{ fontWeight: 'bold' }}>{label}</span>
                  <span
                    style={{ color: theme.colors.vermelho, fontWeight: 'bold' }}
                  >
                    *
                  </span>
                </>
              ) : (
                label
              )}
            </FormLabel>
          )}
          <FormControl
            type="text"
            value={value}
            onChange={onChange}
            placeholder="-23.456789"
            name={name}
            onBlur={onBlur}
            readOnly={readonly}
            style={{
              borderRadius: '10px',
              border: `1px solid ${theme.colors.bordaInput}`,
              textAlign: `${textAlign}`,
              backgroundColor: readonly ? '#ebf0f8' : theme.colors.white,
            }}
            {...props}
          />
        </FormGroup>
      );
    default:
      // Qualquer outro valor
      if (mascara) {
        return FormInputMask(mascara, readonly, label);
      }
      break;
  }
  switch (type) {
    case 'textarea':
    case 'password':
      return FormInput(type, readonly, label);
    default:
      // Aqui aplicamos o tipo como padrão, caso não seja nem `textarea` nem `password`
      return FormInput(type, readonly, label);
  }
};

export default Input;
